/**
 * component-slideshow.js — ヒーロースライダー
 *
 * 機能:
 *  - 自動再生（data-autoplay="true", data-speed="5000" で設定）
 *  - 左右矢印ナビゲーション
 *  - ドットインジケーター
 *  - タッチスワイプ対応（モバイル）
 */

(function () {
  'use strict';

  class Slideshow {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.js-slideshow-track');
      this.slides = Array.from(el.querySelectorAll('.slideshow__slide'));
      this.indicators = Array.from(el.querySelectorAll('.js-slide-indicator'));
      this.prevBtn = el.querySelector('.js-slide-prev');
      this.nextBtn = el.querySelector('.js-slide-next');

      this.current = 0;
      this.total = this.slides.length;
      this.autoplay = el.dataset.autoplay === 'true';
      this.speed = parseInt(el.dataset.speed, 10) || 5000;
      this.timer = null;

      // タッチ用
      this.touchStartX = 0;
      this.touchEndX = 0;

      if (this.total <= 1) return;

      this._bindEvents();
      if (this.autoplay) this._startAutoplay();
    }

    _bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this._prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this._next());
      }

      this.indicators.forEach((dot, i) => {
        dot.addEventListener('click', () => this._goTo(i));
      });

      // タッチスワイプ
      this.el.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.el.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this._handleSwipe();
      }, { passive: true });

      // マウスオーバーで自動再生一時停止
      this.el.addEventListener('mouseenter', () => this._stopAutoplay());
      this.el.addEventListener('mouseleave', () => {
        if (this.autoplay) this._startAutoplay();
      });
    }

    _handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) < 50) return; // 小さいスワイプは無視
      if (diff > 0) {
        this._next();
      } else {
        this._prev();
      }
    }

    _goTo(index) {
      // 範囲外をループ
      if (index < 0) index = this.total - 1;
      if (index >= this.total) index = 0;

      // 旧スライドの active を外す
      this.slides[this.current].classList.remove('is-active');
      if (this.indicators[this.current]) {
        this.indicators[this.current].classList.remove('is-active');
        this.indicators[this.current].setAttribute('aria-selected', 'false');
      }

      this.current = index;

      // 新スライドに active を付ける
      this.slides[this.current].classList.add('is-active');
      if (this.indicators[this.current]) {
        this.indicators[this.current].classList.add('is-active');
        this.indicators[this.current].setAttribute('aria-selected', 'true');
      }

      // トラックをスライド
      this.track.style.transform = `translateX(-${this.current * 100}%)`;
    }

    _next() {
      this._goTo(this.current + 1);
      this._restartAutoplay();
    }

    _prev() {
      this._goTo(this.current - 1);
      this._restartAutoplay();
    }

    _startAutoplay() {
      if (this.timer) return;
      this.timer = setInterval(() => this._next(), this.speed);
    }

    _stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    _restartAutoplay() {
      if (!this.autoplay) return;
      this._stopAutoplay();
      this._startAutoplay();
    }
  }

  // DOM 読み込み後に初期化
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-slideshow').forEach(function (el) {
      new Slideshow(el);
    });
  });
})();
